import { useAuth } from "@/context/AuthContext";
import { ProfileSection } from "@/components/config/ProfileSection";
import { RedProfileSection } from "@/components/config/RedProfileSection";
import { RedPrivacySection } from "@/components/config/RedPrivacySection";
import { DeleteAccountSection } from "@/components/config/DeleteAccountSection";
import { GoogleAccountSection } from "@/components/config/GoogleAccountSection";
import { UsersSection } from "@/components/config/UsersSection";
import { NotificationsSection } from "@/components/config/NotificationsSection";
import { CatalogsSection, VocabularySection } from "@/components/config/CatalogEditor";
import { ExportSection, InstallGuide } from "@/components/config/ExportInstall";

export default function ConfigPage() {
  const { isOwner } = useAuth();
  return (
    <div data-testid="config-page" className="space-y-3">
      <ProfileSection />
      <RedProfileSection />
      <RedPrivacySection />
      <GoogleAccountSection />
      {isOwner && <UsersSection />}
      <NotificationsSection />
      <CatalogsSection canEdit={isOwner} />
      <VocabularySection canEdit={isOwner} />
      <ExportSection />
      <DeleteAccountSection />
      <InstallGuide />
    </div>
  );
}
